'use client';

import { FC, ReactNode } from 'react';

import { TeliaThemeProvider } from '@telialt/common-theme/src/TeliaThemeProvider';

import GlobalStyle from './Global.styles';
import { StyledComponentsRegistry } from './StyledComponentsRegistry';

type Props = {
    skipGlobalStyles?: boolean;
    children: ReactNode;
};

export const StyledComponentsProvider: FC<Props> = ({ skipGlobalStyles, children }) => {
    return (
        <StyledComponentsRegistry>
            <TeliaThemeProvider>
                {!skipGlobalStyles && <GlobalStyle />}
                {children}
            </TeliaThemeProvider>
        </StyledComponentsRegistry>
    );
};
